const UPDATE_FORM = 'UPDATE_FORM';
const UPDATE_ACTIVE_CODE = 'UPDATE_ACTIVE_CODE';
const UPDATA_EXIST_ACTIVE_CODE = 'UPDATA_EXIST_ACTIVE_CODE';
const UPDATE_NO_REPORT_CODE = 'UPDATE_NO_REPORT_CODE';
const UPDATE_SHOW_LOCATION = 'UPDATE_SHOW_LOCATION';
const UPDATE_LOCATION_STREET = 'UPDATE_LOCATION_STREET';
const UPDATE_COMPANY_SEARCH = 'UPDATE_COMPANY_SEARCH';
const UPDATE_QUERY_ACTIVE_CODE = 'UPDATE_QUERY_ACTIVE_CODE';
const CLEAR_DATA = 'CLEAR_DATA';
const UPDATE_ADDRESS = 'UPDATE_ADDRESS';

export default {
  UPDATE_FORM,
  UPDATE_ACTIVE_CODE,
  UPDATA_EXIST_ACTIVE_CODE,
  UPDATE_NO_REPORT_CODE,
  UPDATE_SHOW_LOCATION,
  UPDATE_LOCATION_STREET,
  UPDATE_COMPANY_SEARCH,
  UPDATE_QUERY_ACTIVE_CODE,
  CLEAR_DATA,
  UPDATE_ADDRESS
};



// WEBPACK FOOTER //
// ./src/stores/form/_types.js